Vue.component('vacation-search-location', {
    props: ['vacationId', 'locationsVisited', 'locationClass', 'label', 'maxLines'],
    template: `
        <div class="location-section" v-if="locationsVisitedParsed">
            <span class="locationLabel">{{label}}</span>
            <div class="tour-locations" :class="locationClass">{{displayedLocations}}<span class="search-ellipsis" v-if="hasOverflow"> ...<span class="overflow-locations-more-link" @click.prevent.stop="showMore" @mouseover="showMore" @mouseleave="hideMore">more</span></span></div>
            <span v-if="hasOverflow" class="overflow-locations" :class="{showmore: showOverflow}" @click.prevent.stop="hideMore">
                <span class="overflow-locations-popup">{{locationsVisitedParsed}}</span>
            </span>
        </div>
    `,
    data: function () {
        return {
            isMounted: false,
            showOverflow: false
        };
    },
    computed: {
        locationsVisitedParsed: function () {
            var parsedText = $.parseHTML(this.locationsVisited);
            if (parsedText && parsedText.length > 0) {
                return parsedText[0].wholeText;
            }
            else return '';
        },
        locationText: function () {
            // Until the component is mounted, we are not able to determine the width or calculate "shown" or "hidden" segments of the location string
            if (!this.isMounted || !this.$el || typeof (this.$el.getElementsByClassName) !== 'function') {
                return { full: this.locationsVisitedParsed, shown: '', hidden: '' };
            }

            var known = window.VacationSearchClamper.known[this.locationClass];
            if (!known || !known.offset) {
                var offset = $(this.$el.getElementsByClassName('locationLabel')[0]).outerWidth();
                known = window.VacationSearchClamper.known[this.locationClass] = { offset, results: {} };
            }

            var result = known.results.hasOwnProperty(this.locationsVisitedParsed) ? known.results[this.locationsVisitedParsed] : null;
            if (!result) {
                var textElement = this.$el.getElementsByClassName('tour-locations')[0];
                result = known.results[this.locationsVisitedParsed] = window.VacationSearchClamper.clamp(textElement, this.locationsVisitedParsed, this.maxLines, known.offset, ' ...more');
            }

            return result;
        },
        displayedLocations: function() {
            return (this.locationText ? this.locationText.shown : '');
        },
        hasOverflow: function() {
            return !!(this.locationText ? this.locationText.hidden : false);
        }
    },
    mounted: function () {
        this.isMounted = true;
    },
    methods: {
        showMore: function () { this.showOverflow = true; },
        hideMore: function () { this.showOverflow = false; }
    }
});

function Clamp() {
    var self = this;

    self.known = {};
    self.clamp = function (element, text, allowedLines, firstLineCharOffset, ellipsisText) {
        if (self.known.hasOwnProperty(text)) return self.known[text];

        var existingDisplay = element.style.display;
        element.style.display = "block";
        var lineWidth = element.clientWidth;
        element.style.display = existingDisplay;

        var measure = document.createElement(element.tagName);
        measure.className = element.className;
        measure.style.display = "block";
        measure.style.position = "absolute";
        measure.style.whiteSpace = "nowrap";
        measure.style.visibility = "hidden";
        element.parentElement.appendChild(measure);

        var result = { full: text, shown: text, hidden: null };
        var lineStart = 0;
        var wordStart = 0;
        var lineCount = 1;
        var wasNewLine = false;
        firstLineCharOffset = firstLineCharOffset || 0;

        text.replace(/,|.$/g, function (m, pos) {
            if (lineCount > allowedLines) {
                return;
            }

            // Check line length
            var end = pos + 1;
            var isLastLine = lineCount === allowedLines || text.indexOf(',', pos + m.length) === -1;
            measure.innerText = text.substring(lineStart, end) + (isLastLine ? ellipsisText : '');
            var isLineTooLong = lineWidth < measure.clientWidth + (lineCount === 1 ? firstLineCharOffset : 0);

            if (isLineTooLong && isLastLine && end === text.length) {
                measure.innerText = text.substr(lineStart);
                isLineTooLong = lineWidth < measure.clientWidth + (lineCount === 1 ? firstLineCharOffset : 0);
            }
            if (isLineTooLong) {
                if (wasNewLine) {
                    lineStart = pos + m.length;
                } else {
                    lineStart = wordStart;
                }

                wasNewLine = true;
                lineCount++;
            } else {
                wasNewLine = false;
            }

            wordStart = end;
        });

        if (text.substr(lineStart).length > 0 && lineCount > allowedLines) {
            result.shown = text.substr(0, lineStart);
            result.hidden = text.substr(lineStart);
        }

        element.parentElement.removeChild(measure);

        return result;
    };
}
window.VacationSearchClamper = new Clamp();